import React from 'react'

function DateInput({ 
  value, 
  onChange, 
  label,
  labelClass,
  inputClass,
  id,
  disabled
}) {
  return (
    <>
      <label id={id} className={` my-auto font-semibold text-secondary ${labelClass}`}>{label}</label>
      
      <input 
            type='date'
            value={value}
            onChange={onChange}
            className={`bg-light focus:outline-none rounded text-sm leading-none text-secondary py-3 w-full pl-3 pr-2  mt-2 ${inputClass}`}
            disabled={disabled}
        />
    </>
  )
}

export default DateInput;